(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["v9-commission"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const root = document.querySelector('[data-mrg-commission]');
  if (!root || root.dataset.ready) return; root.dataset.ready = 'true';
  const $ = (selector) => root.querySelector(selector);
  const config = JSON.parse($('#commission-config').textContent);
  const msg = config.messages;
  const $$ = (selector) => [...root.querySelectorAll(selector)];
  const money = (value) => '$' + value.toLocaleString('en-US');
  const form = $('#commission-form');
  const files = [];
  let total = 1199;
  let sizeText = '16 × 20″';
  let validSize = true;
  const selectedSize = () => $('input[name="size"]:checked');
  const inspiration = () => $('input[name="inspiration"]:checked').value;
  function updatePrice() {
    const custom = selectedSize().value === 'custom';
    $('#custom-dimensions').hidden = !custom;
    $('#dimension-error').textContent = '';
    validSize = true;
    if (custom) {
      const w = Number($('#canvas-width').value);
      const h = Number($('#canvas-height').value);
      validSize = w >= 10 && h >= 10 && Number.isInteger(w * 2) && Number.isInteger(h * 2) && Math.max(w, h) <= 36 && Math.min(w, h) <= 24;
      if (validSize) {
        total = Math.max(w, h) <= 20 && Math.min(w, h) <= 16 ? 1199 : 1599;
        sizeText = `${w} × ${h}″`;
      } else {
        sizeText = msg.custom;
        if ($('#canvas-width').value && $('#canvas-height').value) $('#dimension-error').textContent = msg.invalid;
      }
    } else {
      total = Number(selectedSize().dataset.price);
      sizeText = selectedSize().value.split('x').join(' × ') + '″';
    }
    $$('[data-total]').forEach(el => { el.textContent = validSize ? money(total) : msg.choose; });
    $$('[data-balance]').forEach(el => { el.textContent = validSize ? money(total - 299) : '—'; });
    $('#summary-size').textContent = sizeText;
  }
  $$('input[name="size"]').forEach(el => el.addEventListener('change', updatePrice));
  ['#canvas-width', '#canvas-height'].forEach(id => $(id).addEventListener('input', updatePrice));
  $$('input[name="inspiration"]').forEach(el => el.addEventListener('change', () => {
    const idea = inspiration() === 'idea';
    $('#idea-panel').hidden = !idea;
    $('#idea').required = idea;
    $('#upload-label').textContent = idea ? msg.styles : msg.photo;
    $('#upload-requirement').textContent = idea ? msg.optional : msg.required;
    $('#file-error').textContent = '';
    $('#idea-error').textContent = '';
    $('#idea').classList.remove('has-error');
  }));
  function renderFiles() {
    const parent = $('#file-previews');
    parent.replaceChildren();
    files.forEach((record, index) => {
      const item = document.createElement('div'); item.className = 'file-preview';
      {
        const image = document.createElement('img'); image.src = record.url; image.alt = msg.preview; item.append(image);
      }
      const label = document.createElement('div'); label.className = 'file-name'; label.append(document.createTextNode(record.file.name));
      const size = document.createElement('small'); size.textContent = (record.file.size / 1024 / 1024).toFixed(1) + msg.local; label.append(size); item.append(label);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.setAttribute('aria-label', msg.remove + record.file.name);
      remove.addEventListener('click', () => { URL.revokeObjectURL(record.url); files.splice(index, 1); renderFiles(); }); item.append(remove); parent.append(item);
    });
  }
  function addFiles(incoming) {
    const errors = [];
    for (const file of incoming) {
      if (files.some(r => r.file.name === file.name && r.file.size === file.size && r.file.lastModified === file.lastModified)) continue;
      if (files.length >= 3) { errors.push(msg.maxfiles); break; }
      if (!/\.(jpe?g|png|webp)$/i.test(file.name)) { errors.push(msg.filetype); continue; }
      if (file.size > 10 * 1024 * 1024) { errors.push(msg.filesize); continue; }
      files.push({ file, url: URL.createObjectURL(file) });
    }
    $('#file-error').textContent = [...new Set(errors)].join(' ');
    $('#dropzone').classList.remove('has-error');
    renderFiles();
  }
  $('#choose-files').addEventListener('click', () => $('#reference-files').click());
  $('#reference-files').addEventListener('change', e => { addFiles(e.target.files); e.target.value = ''; });
  const drop = $('#dropzone');
  ['dragenter', 'dragover'].forEach(event => drop.addEventListener(event, e => { e.preventDefault(); drop.classList.add('dragover'); }));
  ['dragleave', 'drop'].forEach(event => drop.addEventListener(event, e => { e.preventDefault(); drop.classList.remove('dragover'); }));
  drop.addEventListener('drop', e => addFiles(e.dataTransfer.files));
  ['#email', '#idea'].forEach(id => $(id).addEventListener('input', () => { $(id).classList.remove('has-error'); $(id + '-error').textContent = ''; }));
  form.addEventListener('submit', e => {
    e.preventDefault();
    updatePrice();
    let target;
    if (!validSize) { $('#dimension-error').textContent = msg.invalid; target = $('#canvas-width'); }
    if (inspiration() === 'photo' && !files.length) { $('#file-error').textContent = msg.filemissing; drop.classList.add('has-error'); target ||= $('#choose-files'); }
    if (inspiration() === 'idea' && !$('#idea').value.trim()) { $('#idea-error').textContent = msg.ideamissing; $('#idea').classList.add('has-error'); target ||= $('#idea'); }
    if (!$('#email').validity.valid) { $('#email-error').textContent = msg.emailmissing; $('#email').classList.add('has-error'); target ||= $('#email'); }
    if (target) { target.focus(); target.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    $('#review-size').textContent = sizeText;
    $('#review-inspiration').textContent = inspiration() === 'photo' ? `${files.length}${msg.reference_photos}` : $('#idea').value.trim().slice(0, 170);
    $('#review-email').textContent = $('#email').value;
    $('#review-notes-row').hidden = !$('#notes').value.trim();
    $('#review-notes').textContent = $('#notes').value.trim();
    $('#review-dialog').showModal();
  });
  $$('.close-dialog').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
  $$('.return-form').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
  $$('.edit-details').forEach(button => button.addEventListener('click', () => $('#review-dialog').close()));
  $$('[data-consult]').forEach(button => button.addEventListener('click', () => $('#consult-dialog').showModal()));
    $$('dialog').forEach(dialog => dialog.addEventListener('click', e => { if (e.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); }));
  function decorateDimension(input, other, dimension) {
    const box = document.createElement('div'); box.className = 'dimension-control vertical';
    input.before(box); box.append(input);
    const arrows = document.createElement('div'); arrows.className = 'dimension-arrows'; box.append(arrows);
    const maximum = () => Number(other.value) > 24 ? 24 : 36;
    function adjust(direction) {
      const current = input.value === '' ? 10 : Number(input.value);
      const next = direction > 0 ? Math.floor(current * 2 + 1) / 2 : Math.ceil(current * 2 - 1) / 2;
      input.value = String(Math.max(10, Math.min(maximum(), next)));
      input.dispatchEvent(new Event('input', {bubbles:true}));
    }
    [1,-1].forEach(direction => {
      const button = document.createElement('button'); button.type = 'button';
      button.setAttribute('aria-label',msg[(direction>0?'increase_':'decrease_')+dimension]);
      button.innerHTML = '<svg aria-hidden="true" viewBox="0 0 16 16"><path d="'+(direction>0?'m4 10 4-4 4 4':'m4 6 4 4 4-4')+'"/></svg>';
      button.addEventListener('click',()=>adjust(direction)); arrows.append(button);
      const refresh = () => {button.disabled = input.value !== '' && (direction>0 ? Number(input.value)>=maximum() : Number(input.value)<=10);};
      input.addEventListener('input',refresh); other.addEventListener('input',refresh);refresh();
    });
    input.addEventListener('keydown',event=>{if(['ArrowUp','ArrowDown'].includes(event.key)){event.preventDefault();adjust(event.key==='ArrowUp'?1:-1);}});
  }
  decorateDimension($('#canvas-width'),$('#canvas-height'),'width');
  decorateDimension($('#canvas-height'),$('#canvas-width'),'height');
  const checkout = $('#commission-checkout');
  let busy = false, locked = false;
  let requestId = 'MRG-'+crypto.randomUUID().replaceAll('-','').slice(0,16).toUpperCase();
  const apiRoot = config.root.endsWith('/') ? config.root : config.root+'/';
  async function cartRead() {
    const response = await fetch(apiRoot+'cart.js',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(30000)});
    if(!response.ok) throw new Error(msg.error);
    return response.json();
  }
  function proceed() {
    location.assign(apiRoot+'checkout?checkout[email]='+encodeURIComponent($('#email').value.trim()));
  }
  checkout.addEventListener('click',async()=>{
    if(busy)return;
    $('#checkout-error').textContent='';
    if(!config.enabled){$('#checkout-error').textContent=msg.unavailable;return;}
    busy=true;checkout.disabled=true;checkout.textContent=msg.busy;
    $$('#review-dialog .edit-details, #review-dialog .close-dialog').forEach(b=>b.disabled=true);
    try {
      const cart=await cartRead();
      const own=cart.items.find(item=>item.properties?.['Commission reference']===requestId);
      if(own){
        if(own.quantity!==1 || own.original_price!==29900)throw new Error(msg.error);
        for(let i=0;i<files.length;i++){if(!/^https?:\/\//.test(own.properties?.['Reference '+(i+1)]||''))throw new Error(msg.error);}
        proceed();return;
      }
      const other=cart.items.find(item=>[Number(config.small),Number(config.large)].includes(item.variant_id));
      if(other)throw new Error(msg.duplicate);
      const data=new FormData();
      data.append('id',total===1199?config.small:config.large);data.append('quantity','1');
      const properties={
        'Commission reference':requestId,
        'Canvas':sizeText,
        'Painting total':money(total)+' USD before tax',
        'Remaining balance':money(total-299)+' USD before tax',
        'Starting point':inspiration()==='photo'?'Photo':'Idea / style',
        'Idea':$('#idea').value.trim(),
        'Notes':$('#notes').value.trim(),
        'Commission email':$('#email').value.trim(),
        'First name':$('#first-name').value.trim(),
        '_Creation authorization':'Not yet authorized — explicit final-plan approval required',
        '_Deposit policy':'$299 refundable before final-plan approval and authorization. After authorization: $199 non-refundable; $100 refundable on cancellation without receiving the painting.',
        '_commission_policy_version':'2026-09-29'
      };
      for(const [key,value] of Object.entries(properties)){if(value)data.append('properties['+key+']',value);}
      files.forEach((record,index)=>data.append('properties[Reference '+(index+1)+']',record.file,record.file.name));
      locked=true;
      const response=await fetch(apiRoot+'cart/add.js',{method:'POST',credentials:'same-origin',body:data,signal:AbortSignal.timeout(120000)});
      if(!response.ok){const err=await response.json().catch(()=>({}));locked=false;throw new Error(err.description||msg.error);}
      const saved=await cartRead();
      const line=saved.items.find(item=>item.properties?.['Commission reference']===requestId);
      if(!line||line.quantity!==1||line.original_price!==29900)throw new Error(msg.error);
      for(let i=0;i<files.length;i++){if(!/^https?:\/\//.test(line.properties?.['Reference '+(i+1)]||''))throw new Error(msg.error);}
      proceed();
    } catch(error) {
      $('#checkout-error').textContent=error.name==='TimeoutError'?msg.error:(error.message||msg.error);
      if(error.message===msg.duplicate){const a=document.createElement('a');a.href=apiRoot+'cart';a.textContent=' Review cart →';$('#checkout-error').append(a);}
    } finally {
      busy=false;checkout.disabled=false;checkout.textContent=msg.retry;
      $$('#review-dialog .edit-details, #review-dialog .close-dialog').forEach(b=>b.disabled=locked);
    }
  });
  $('#review-dialog').addEventListener('cancel',event=>{if(busy||locked)event.preventDefault();});
  $('#review-dialog').addEventListener('click',event=>{
    if((busy||locked)&&event.target===$('#review-dialog'))event.stopImmediatePropagation();
  },true);
  if(!config.enabled){checkout.disabled=true;$('#checkout-error').textContent=msg.unavailable;}

  updatePrice();
})();
  } catch(e) { console.error(e); }
})();

})();
